import React from "react";
import styled from "styled-components";

interface SpinnerProps {
  size?: number;
}

const Spinner = ({ size = 100 }: SpinnerProps) => {
  const barCount = 16;
  const radius = size / 3.5;
  const barHeight = radius * 0.7;
  const barWidth = size * 0.06;

  return (
    <Style
      $size={size}
      $barHeight={barHeight}
      $barWidth={barWidth}
      $radius={radius}
    >
      <div className="spinner">
        {Array.from({ length: barCount }).map((_, i) => (
          <div key={i} style={{ "--i": i + 1 } as React.CSSProperties}></div>
        ))}
      </div>
    </Style>
  );
};

export default Spinner;

const Style = styled.div<{
  $size: number;
  $barHeight: number;
  $barWidth: number;
  $radius: number;
}>`
  @keyframes spinFade {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0.2;
    }
  }

  .spinner {
    position: relative;
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
  }

  .spinner div {
    position: absolute;
    top: 30%;
    left: 50%;
    width: ${({ $barWidth }) => $barWidth}px;
    height: ${({ $barHeight }) => $barHeight}px;
    background: white;
    border-radius: ${({ $barWidth }) => $barWidth / 2}px;

    transform: rotate(calc((var(--i) - 1) * 22.5deg))
      translateY(-${({ $radius }) => $radius}px);

    transform-origin: center bottom;
    opacity: 0.2;
    animation: spinFade 2.4s linear infinite;
    animation-delay: calc((var(--i) - 1) * -0.15s);
  }
`;
